import { gql } from '@apollo/client'

export const GET_SONG_ROLES = gql`
  query {
    getSongRoles {
      code
    }
  }
`
